import React, { MouseEvent } from 'react';
import { IconContainer, Facebook, Twitter } from '@icons/common';

interface SocialMediaShareProps {
  title: string;
}

export const SocialMediaShare = ({ title }: SocialMediaShareProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>, name: string) => {
    e.preventDefault();

    window.open(
      e.currentTarget.href,
      name + "Share Window",
      "height=450, width=550, top=" +
      (window.innerHeight / 2 - 275) +
      ", left=" +
      (window.innerWidth / 2 - 225) +
      ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
    );
  };

  const shareUrl = window.location.href;

  return (
    <div className="l-share-buttons-container">
      <span className="share">{title}</span>
      <div className="l-share-buttons-container-links">
        {/* <!-- Facebook --> */}
        <div className="c-share-link is-facebook ">
          <a
            href={"http://www.facebook.com/sharer.php?u=" + shareUrl}
            onClick={(e) => handleClick(e, "Facebook")}>
            <IconContainer icon={<Facebook />} />
          </a>
        </div>

        {/* <!-- Twitter --> */}
        <div className="c-share-link is-twitter">
          <a
            onClick={(e) => handleClick(e, "Twitter")}
            href={
              "https://twitter.com/share?url=" + shareUrl + "&text=Alfalaval&hashtags=alfalaval"
            }>
            <IconContainer icon={<Twitter />} />
          </a>
        </div>

        {/* <!-- Linkedin--> */}
        <div className="c-share-link is-linkedin">
          <a
            onClick={(e) => handleClick(e, "LinkedIn")}
            href={"http://www.linkedin.com/shareArticle?mini=true&url=" + shareUrl}>
            <i className="icon-linkedin" aria-hidden="true" />
          </a>
        </div>

        {/* <!-- Mail --> */}
        <div className="c-share-link is-mail">
          <a href={"mailto:?Subject=Alfalaval&Body=" + shareUrl}>
            <i className="icon-envelope" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
};
